import React from 'react';
/**
 * Component for displaying potential troubleshooting solutions for recording issues.
 * It contains a message with a link to a help article.
 */
const RecorderPotentialMsg = () => (
    <div className="troubleshoot-message font-size-14px margin-t-16px flex justify-content-center text-align-left">
        Have trouble recording your video?&nbsp;<a href="https://community.thankview.com/t/h7hzab8/help-video-issues" target="_blank" rel="noopener noreferrer" className="font-blue-48">Try these potential solutions</a>.
    </div>
);

export default RecorderPotentialMsg;
